import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type ProgramUpdateResponse = ResponseType<null>;

function useProgramUpdateMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<ProgramUpdateResponse>["response"],
    AxiosResponseAndError<ProgramUpdateResponse>["error"],
    {value:string,id:string}
  >({
    mutationFn: (data) =>
      ApiRequest.put<ProgramUpdateResponse>(
        `${requestURLs.project}/program-update/${data.id}`,
        data
      ),
  });

  return mutation;
}
export default useProgramUpdateMutation;
